import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import {
  getConfigs,
  getSingleStats,
  getMultiStats,
  selectMarcacionesConfigs,
  selectMarcacionesSingleStats,
  selectMarcacionesMultiStats,
  selectCurrentConfigId,
  marcacionesSetCurrentConfigId,
  selectMarcacionesConfigsLoading,
  selectMarcacionesStatsLoading,
  selectMarcacionesStartDate,
  selectMarcacionesEndDate,
  marcacionesSetEndDate,
  marcacionesSetStartDate,
} from "./marcacionesSlice";
import "./MarcacionesStatsPage.scss";
import { FilterComponent } from "../components/sidePanel/FilterComponent";
import { DropDown } from "../../common/components/Btns/DropDown";
import { ViewConfig, MultiStats } from "./marcacionesV2API";
import { EchartsFunnel } from "../repoteria/dashboardComponents/components/EchartsFunnel";

export const MarcacionesStatsPage = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const configs = useAppSelector(selectMarcacionesConfigs) || [];
  const singleStats = useAppSelector(selectMarcacionesSingleStats);
  const multiStats = useAppSelector(selectMarcacionesMultiStats);
  const currentConfigId = useAppSelector(selectCurrentConfigId);
  const configsLoading = useAppSelector(selectMarcacionesConfigsLoading);
  const statsLoading = useAppSelector(selectMarcacionesStatsLoading);
  const startDate = useAppSelector(selectMarcacionesStartDate);
  const endDate = useAppSelector(selectMarcacionesEndDate);
  const [selectedTab, setSelectedTab] = useState<"SINGLE" | "MULTI" | "FUNNEL">(
    "MULTI"
  );
  const [selectedConfig, setSelectedConfig] = useState<ViewConfig | null>(null);
  const [nameConfig, setNameConfig] = useState<string>("");
  useEffect(() => {
    dispatch(getConfigs());
  }, [dispatch]);

  const handleConfigSelect = (id: string) => {
    console.log("Selected Config ID:", id);
    dispatch(marcacionesSetCurrentConfigId(id));
  };

  const handleLoadMultiStats = () => {
    if (currentConfigId) {
      dispatch(
        getMultiStats({
          viewConfigId: currentConfigId,
          startDatetime: startDate,
          endDatetime: endDate,
        })
      );
    }
  };

  // Helper to download MultiStats as CSV
  function downloadMultiStatsCSV() {
    if (!multiStats?.stats?.length) return;
    const stats = multiStats.stats;
    const firstCount = stats.length > 0 ? stats[0].count : 0;
    const headers = [
      "Evento",
      "Promedio (s)",
      "Conteo",
      "Porcentaje",
      "Máx (s)",
      "Mín (s)",
      "Stdev (s)",
    ];
    const rows = stats.map((stat) => {
      const percent = firstCount
        ? ((stat.count / firstCount) * 100).toFixed(1) + "%"
        : "-";
      return [
        stat.eventName,
        stat.eventName2 || "-",
        (stat.averageDurationMs / 1000).toFixed(2),
        stat.count,
        percent,
        (stat.maxDurationMs / 1000).toFixed(2),
        (stat.minDurationMs / 1000).toFixed(2),
        (stat.stdevDurationMs / 1000).toFixed(2),
      ];
    });
    const csvContent = [headers, ...rows]
      .map((row) =>
        row.map((field) => `"${String(field).replace(/"/g, '""')}"`).join(",")
      )
      .join("\n");
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "marcaciones_stats.csv");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  }

  const renderDropdown = () => (
    <div className="marcaciones-dropdown">
      <div>
        <FilterComponent
          key={0}
          hasCalendar={false}
          calendarType="double"
          open={false}
          endDate={endDate ? new Date(endDate) : null}
          startDate={startDate ? new Date(startDate) : null}
          setEndDate={(date: Date) => {
            if (date) {
              dispatch(marcacionesSetEndDate(date.toISOString()));
            } else {
              dispatch(marcacionesSetEndDate(null));
            }
          }}
          setStartDate={(date: Date) => {
            if (date) {
              dispatch(marcacionesSetStartDate(date.toISOString()));
            } else {
              dispatch(marcacionesSetStartDate(null));
            }
          }}
          items={[]}
        />
      </div>
      <DropDown
        key={"Configs"}
        title="Reporte"
        options={configs.map((config) => ({
          label: config.viewName,
          value: config._id,
        }))}
        onChange={(e) => {
          handleConfigSelect(e.value);
          setNameConfig(e.label);
        }}
      />
      {configsLoading === "pending" ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: 100,
          }}
        >
          <span className="loader" />
          <span style={{ marginLeft: 8 }}>Cargando configuraciones...</span>
        </div>
      ) : (
        <>
          {currentConfigId && (
            <button
              className="boton1"
              style={{ marginTop: "20px", width: "100%" }}
              onClick={handleLoadMultiStats}
            >
              Cargar estadísticas
            </button>
          )}
          {statsLoading === "resolved" && (
            <button
              className="boton1"
              style={{ marginTop: "10px", width: "100%" }}
              onClick={downloadMultiStatsCSV}
              disabled={!multiStats?.stats?.length}
            >
              Descargar CSV
            </button>
          )}
        </>
      )}
    </div>
  );

  const renderTabs = () => (
    <>
      {statsLoading === "pending" && (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            marginBottom: 12,
          }}
        >
          <span className="loader" />
          <span style={{ marginLeft: 8 }}>Cargando estadísticas...</span>
        </div>
      )}
      {statsLoading === "resolved" && (
        <div className="marcaciones-tabs">
          {/* <button
          className={selectedTab === "SINGLE" ? "tab-selected" : "tab"}
          onClick={() => setSelectedTab("SINGLE")}
        >
          Single Stats
        </button> */}
          <button
            className={selectedTab === "MULTI" ? "tab-selected" : "tab"}
            onClick={() => setSelectedTab("MULTI")}
          >
            Estadísticas
          </button>
          <button
            className={selectedTab === "FUNNEL" ? "tab-selected" : "tab"}
            onClick={() => setSelectedTab("FUNNEL")}
          >
            Embudo {nameConfig ? `${nameConfig}` : ""}
          </button>
        </div>
      )}
    </>
  );

  const renderSingleStats = () => (
    <div className="stats-content">
      {singleStats?.stats?.length ? (
        <table className="stats-table">
          <thead>
            <tr>
              <th>Evento</th>
              <th>Fecha</th>
              <th>Duración (s)</th>
            </tr>
          </thead>
          <tbody>
            {singleStats.stats.map((stat) => (
              <tr key={stat.eventName + stat.date}>
                <td>{stat.eventName}</td>
                <td>{stat.date}</td>
                <td>{(stat.durationMs / 1000).toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <div>No hay datos de Single Stats.</div>
      )}
    </div>
  );

  const getStatsWithPercent = (stats: MultiStats[]) => {
    const firstCount = stats.length > 0 ? stats[0].count : 0;

    return stats.map((stat) => {
      const percent = firstCount
        ? ((stat.count / firstCount) * 100).toFixed(1)
        : "-";
      return { ...stat, percent };
    });
  };

  const renderMultiStats = () => {
    const stats = getStatsWithPercent(multiStats?.stats || []);
    return (
      <div className="stats-content">
        {stats.length ? (
          <table className="stats-table">
            <thead>
              <tr>
                <th>Evento</th>
                <th>Promedio (s)</th>
                <th>Conteo</th>
                <th>Porcentaje</th>
                <th>Máx (s)</th>
                <th>Mín (s)</th>
                <th>Stdev (s)</th>
              </tr>
            </thead>
            <tbody>
              {stats.map((stat) => {
                return (
                  <tr
                    key={stat.eventName + (stat.eventName2 || "") + stat.count}
                  >
                    <td>{stat.eventName}</td>
                    <td>{(stat.averageDurationMs / 1000).toFixed(2)}</td>
                    <td>{stat.count}</td>
                    <td>{stat.percent !== "-" ? stat.percent + "%" : "-"}</td>
                    <td>{(stat.maxDurationMs / 1000).toFixed(2)}</td>
                    <td>{(stat.minDurationMs / 1000).toFixed(2)}</td>
                    <td>{(stat.stdevDurationMs / 1000).toFixed(2)}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        ) : (
          <div>No hay datos de Multi Stats.</div>
        )}
      </div>
    );
  };

  const renderFunnel = () => {
    const stats = getStatsWithPercent(multiStats?.stats || []);

    const funnelData = stats.map((stat) => ({
      eventName: stat.eventName,
      count: stat.count,
      percent: stat.percent === "-" ? 0 : parseInt(stat.percent),
    }));

    if (funnelData.length === 0) {
      return <div>No hay datos para el embudo.</div>;
    }
    return <EchartsFunnel funnelData={funnelData}></EchartsFunnel>;
  };

  return (
    <div className="marcaciones-stats-page">
      <button
        className="back-button"
        style={{ position: "absolute", top: 24, left: 24, zIndex: 10 }}
        onClick={() => navigate(-1)}
      >
        {"< Volver"}
      </button>
      <div className="left-panel" style={{ marginTop: 48 }}>
        {renderDropdown()}
      </div>
      <div className="right-panel">
        {renderTabs()}
        {selectedTab === "SINGLE" && renderSingleStats()}
        {selectedTab === "MULTI" && renderMultiStats()}
        {selectedTab === "FUNNEL" && renderFunnel()}
      </div>
    </div>
  );
};

export default MarcacionesStatsPage;
